var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterButtn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "120px",
    height: "98px",
    viewBox: "0 0 120 98",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "twitter_buttn") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-1",
    transform: "translate(-332.000000, -286.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "twitter_buttn",
    transform: "translate(332.000000, 273.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L120,0 L120,120 L0,120 L0,0 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,24.8777205 C115.584769,26.8358023 110.839899,28.1591865 105.859761,28.7543802 C110.943048,25.7073046 114.846483,20.8825487 116.684736,15.1338381 C111.928015,17.954863 106.659058,20.0038041 101.051245,21.1081605 C96.560079,16.3233476 90.161747,13.3333333 83.0808735,13.3333333 C69.4840338,13.3333333 58.4606606,24.3562676 58.4606606,37.9522294 C58.4606606,39.8817806 58.6788105,41.7608545 59.0984308,43.562676 C38.6371118,42.5360108 20.4964337,32.7346282 8.35378031,17.8398625 C6.2346099,21.4759867 5.02052014,25.7051099 5.02052014,30.2169063 C5.02052014,38.7581111 9.36727752,46.2937196 15.9732251,50.7085117 C11.9372325,50.580782 8.14133655,49.4733531 4.82168331,47.6293939 C4.81992758,47.7321043 4.81992758,47.8352537 4.81992758,47.9388419 C4.81992758,59.8672958 13.3062658,69.8179158 24.5688577,72.0793006 C22.5027982,72.6420132 20.3278832,72.9426826 18.0823,72.9426826 C16.4959947,72.9426826 14.9535828,72.788617 13.4506749,72.5011156 C16.5833425,82.2823073 25.6754088,89.4000512 36.4485899,89.598888 C28.0228245,96.201763 17.4072205,100.137679 5.87292878,100.137679 C3.88587732,100.137679 1.92603972,100.021361 0,99.7939939 C10.8952047,106.77918 23.8362778,110.854676 37.739493,110.854676 C83.0233732,110.854676 107.786239,73.3403563 107.786239,40.8070522 C107.786239,39.7395662 107.762537,38.6777863 107.715132,37.6221515 C112.524964,34.1510662 116.699221,29.8148433 120,24.8777205",
    id: "Fill-1",
    fill: "#FFFFFF"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterButtn);
export default __webpack_public_path__ + "static/media/twitter_buttn.a68d48d8d8bff7111c70a189039e5546.svg";
export { ForwardRef as ReactComponent };